import { API_ENDPOINTS, fetchAPI } from 'components/graphql/FetchApi'
import { bid as placeBid, findInventoryById } from 'components/graphql/queries'
import { openModal } from 'components/modal/modules/dispatcher/methods';
import { stripUriParamsString } from 'lib/utils/helpers';
import queryString from 'query-string';
import React, { useEffect, useState } from 'react'
import Moment from 'react-moment'
import { withRouter } from 'react-router-dom';


const BidConfirmation: React.FC<{ [label: string]: any }> = (props: any) => {

    const n: any = stripUriParamsString(props.match.params.name)
    const parsedName: any = n.split('SPACE').join(' ')

    const [name] = useState(parsedName)
    const [email] = useState(stripUriParamsString(props.match.params.email))
    const [phoneNumber] = useState(stripUriParamsString(props.match.params.phoneNumber))
    const [campaignId] = useState(stripUriParamsString(props.match.params.campaignId))
    const [sellerId] = useState(stripUriParamsString(props.match.params.sellerId))
    const [bid] = useState(stripUriParamsString(props.match.params.bid))
    const [bidId] = useState(stripUriParamsString(props.match.params.bidId))

    const [createdBy] = useState(stripUriParamsString(props.match.params.createdBy))
    const [username] = useState(stripUriParamsString(props.match.params.username))
    const [subdomain] = useState(stripUriParamsString(props.match.params.subdomain))

    const params = queryString.parse(props.location.search)
    const [sessionId] = useState(params.session_id)

    const [floorplanLocationX] = useState(stripUriParamsString(props.match.params.floorplanLocationX))
    const [floorplanLocationY] = useState(stripUriParamsString(props.match.params.floorplanLocationY))
    const [address] = useState(stripUriParamsString(props.match.params.address))

    useEffect(() => {
        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: placeBid,
                variables: {
                    name,
                    email,
                    phoneNumber,
                    bid,
                    bidId,
                    campaignId,
                    sellerId,
                    floorplanLocationX: floorplanLocationX === 'NULL' ? null : floorplanLocationX,
                    floorplanLocationY: floorplanLocationY === 'NULL' ? null : floorplanLocationY,
                    address: address === 'NULL' ? null : address,
                    sessionId
                }
            })
            .then(res => {

                console.log(location.hostname)

                let redirectURL = 'https://' + subdomain + '.isotopeticketing.com' + (createdBy === sellerId ? '' : ('/' + username))
                if (location.hostname === 'localhost') {
                    redirectURL = 'http://localhost:3000/sell/' + subdomain + (createdBy === sellerId ? '' : ('/' + username))
                } else if (location.hostname === 'test') {
                    redirectURL = 'https://test.isotopeticketing.com/sell/' + subdomain + (createdBy === sellerId ? '' : ('/' + username))
                }

                if (res.data.data.order.bid !== 'Purchase-Error') {
                    fetchAPI
                        .post(API_ENDPOINTS.BASE_URL, {
                            query: findInventoryById,
                            variables: {
                                id: bidId
                            }
                        })
                        .then(res2 => {
                            const inventoryItem = res2.data.data.inventoryItem.findById
                            const content = <div style={{ padding: '20px' }}>
                                Your bid of ${Number(bid).toFixed(2)} has been placed. The winner will be notified via email on <Moment format="D MMM 'YY, ">
                                    {Number(new Date(
                                        inventoryItem.endTime.year,
                                        inventoryItem.endTime.month - 1,
                                        inventoryItem.endTime.day,
                                        (inventoryItem.endTime.PM ? inventoryItem.endTime.hour + 12 : inventoryItem.endTime.hour),
                                        inventoryItem.endTime.minute
                                    ))}
                                </Moment>
                                <Moment format="hh:mm A">
                                    {Number(new Date(
                                        inventoryItem.endTime.year,
                                        inventoryItem.endTime.month - 1,
                                        inventoryItem.endTime.day,
                                        (inventoryItem.endTime.PM ? inventoryItem.endTime.hour + 12 : inventoryItem.endTime.hour),
                                        inventoryItem.endTime.minute
                                    ))}
                                </Moment>. If you did not win the bid, the authorization hold on your card will be released within 7 days.
                            Please check your email for confirmation.
                            <div style={{ width: '100%', textAlign: 'center', paddingTop: '20px' }}>
                                    <button
                                        role="submit"
                                        type="submit"
                                        className="new-button-save"
                                        onClick={e => { window.location.href = redirectURL }}
                                    >
                                        Done
                                </button>
                                </div>
                            </div>
                            openModal(content, 'Bid Placed!', [])
                        })
                        .catch(err2 => {
                            const content = <div style={{ padding: '20px' }}>
                                Something went wrong. If an authorization hold was placed on your card,
                                please reach out to us at orders@isotopeticketing.com.
                                <div style={{ width: '100%', textAlign: 'center', paddingTop: '20px' }}>
                                    <button
                                        role="submit"
                                        type="submit"
                                        className="new-button-save"
                                        onClick={e => { window.location.href = redirectURL }}
                                    >
                                        Done
                                </button>
                                </div>
                            </div>
                            openModal(content, 'Bid Placed!', [])
                        })
                }
            })
            .catch(err => {
                console.log(err)
            })
    }, [name, email, campaignId, phoneNumber,
        sellerId, bid, bidId, floorplanLocationX,
        username, createdBy, subdomain,
        floorplanLocationY, address, location.hostname])

    return null

}


export default withRouter(BidConfirmation);


// WEBPACK FOOTER //
// ./src/components/confirmTransaction/BidConfirmation.tsx